module.exports = __webpack_public_path__ + "img/arrow-left.12918904.svg";